import { animate, state, style, transition, trigger } from '@angular/animations';
import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, NgModule, OnDestroy, Output } from '@angular/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { OeAppPersonService } from '../../shared/oe-app-person.service';
import { ChatBotIframeModule } from '../chat-bot-iframe/chat-bot-iframe.component';

@Component({
  selector: 'lp2-chat-bot-modal',
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger('openClose', [
      state(
        'open',
        style({
          transform: 'scale(1)',
          opacity: 1,
        })
      ),
      state(
        'close',
        style({
          transform: 'scale(0)',
          opacity: 0,
        })
      ),
      transition('open => close', [animate('0.25s ease-in')]),
      transition('close => open', [animate('0.25s ease-out')]),
    ]),
  ],
  template: `
    <div class="chat-bot-modal-backdrop" *ngIf="!oeAppPersonService.hasSeenCopilotOnboarding && isOpen"></div>
    <div class="chat-bot-modal-window" [@openClose]="isOpen ? 'open' : 'close'" [hidden]="!isOpen" >
      <lp2-chat-bot-iframe
        [chatType]="chatType"
        (close)="closeModal()"
        (onboardingComplete)="onOnboardingComplete()"
      ></lp2-chat-bot-iframe>
    </div>
  `,
  styles: [
    `
      .chat-bot-modal-backdrop {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.5);
        z-index: 1100;
      }

      .chat-bot-modal-window {
        position: fixed;
        width: 375px;
        z-index: 1200;
        right: 80px;
        bottom: 60px;
        background-color: #fff;
        transform-origin: right bottom;
        border-radius: 16px 16px 0 16px;
        box-shadow: 0px 0px 16px 8px rgba(0, 0, 0, 0.1);
      }
    `,
  ],
})
export class ChatBotModalComponent implements OnDestroy {
  @Input() chatType: string;
  @Input() isOpen: boolean = false;
  @Output() onboardingComplete: EventEmitter<void> = new EventEmitter();
  @Output() close: EventEmitter<void> = new EventEmitter();

  constructor(public oeAppPersonService: OeAppPersonService) { }

  ngOnDestroy(): void {
    this.closeModal();
  }

  public closeModal(): void {
    this.isOpen = false;
    setTimeout(() => {
      this.close.emit();
    }, 250); // animation time
  }

  public onOnboardingComplete(): void {
    this.onboardingComplete.emit();
  }
}

@NgModule({
  imports: [CommonModule, NgbModule, ChatBotIframeModule],
  declarations: [ChatBotModalComponent],
  entryComponents: [ChatBotModalComponent],
  exports: [ChatBotModalComponent],
})
export class ChatBotModalModule {}



// WEBPACK FOOTER //
// ./ts/app/components/chat-bot-modal/chat-bot-modal.component.ts